var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty-data-container"},[_c('img',{staticClass:"empty-img",attrs:{"src":_vm.ossProcessImg(_vm.$images.attend_class_empty_none_pcim, 614)}}),_vm._v(" "),_c('div',{staticClass:"tip"},[_vm._t("tip",function(){return [_vm._v(_vm._s(_vm.tip))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }